// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"545":"7a319327","598":"1e573021"}[chunkId] + ".chunk.js";
};